import React from "react";
import { useNavigate } from "react-router-dom";
import { BlockStack, Button, Card, Icon, InlineStack, Spinner, Text } from "@shopify/polaris"
import { LockIcon } from "@shopify/polaris-icons";

import { useGlobalContext } from "context/GlobalContext";

export const LockedCard = ({
  description: _description,
}) => {
  const { store } = useGlobalContext();
  const navigate = useNavigate();

  let description = `You have gone over the order limit for your plan. Upgrade your plan to unlock your account.`;
  if (store?.subscription?.orders_per_month) {
    description = `You have gone over the order limit of ${store.subscription.orders_per_month} for your plan. Upgrade now to unlock your account.`
  }
  if (_description) {
    description = _description;
  }

  const handleUpgradeClick = () => {
    navigate("/settings/plans");
  };

  return (
    <Card>
      <BlockStack align="center" gap="400">
        <Icon
          source={LockIcon}
          tone="base"
        />

        <BlockStack align="center" gap="200">
          <Text variant="headingLg" as="h2" alignment="center">
            Locked
          </Text>
          <Text variant="bodyLg" as="p" alignment="center">
            {description}
          </Text>
        </BlockStack>

        <Button onClick={handleUpgradeClick}>
          Upgrade now
        </Button>
      </BlockStack>
    </Card>
  );
};

export const LockableCard = ({
  children,
  locked,
  loading,
  loadingCardHeight = "260px",
  lockedDescription,
}) => {
  if (loading) {
    return (
      <Card>
        <div style={{ minHeight: loadingCardHeight, display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <InlineStack gap="100" align="center">
            <Spinner size="small" />
            <Text as="p">Loading...</Text>
          </InlineStack>
        </div>
      </Card>
    );
  }

  if (locked) {
    return <LockedCard description={lockedDescription} />;
  }

  return children;
}
